<template>
    <div class='login-box'>
        <div class="login-box-logo">
            <img src='https://server.cottongame.com/serverstore/service/logo.png' alt=''>
            <h3>CottonGame</h3>
        </div>
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" class="login-form">
            <el-form-item prop="phone">
                <el-input size='medium' placeholder="请输入手机号" v-model="ruleForm.phone">
                    <template slot="prepend">+86</template>
                </el-input>
            </el-form-item>
            <el-form-item prop="captcha">
                <el-input size='medium' style='width: 65%' placeholder='请输入验证码' v-model="ruleForm.captcha" autocomplete="off"/>
                &nbsp;&nbsp;<el-button type='text' :disabled='captcha.sendStatus' size='medium' @click='sendCaptchaByPhone' style='float: right'>{{captcha.sendStatus ? `${captcha.resendTime}秒后重新获取`: '获取验证码'}}</el-button>
            </el-form-item>
            <el-form-item>
                <el-button size='medium' style='width: 100%'  type="primary" @click="submitForm">登录</el-button>
            </el-form-item>
            
            <el-divider content-position='center'>或者使用以下方式</el-divider>
            <el-row :gutter='10'>
                <el-col :span='12'>
                    <el-row :gutter='10'>
                        <el-col :span='12'>
                            <el-button type="text" @click="skipPage('login')">账号登录</el-button>
                        </el-col>
                        <el-col :span='12'>
                            <el-button type="text" @click="skipPage('register')">创建账号</el-button>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span='12'>
                    <el-button type="text" @click="skipPage('forgetPwd')">忘记密码</el-button>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { message } from '@/utils/message';
import { loginApi } from '@/service/api/loginApi';
import { localStg } from '@/utils/storage/local';
import { EnumLocalStore } from '@/constant/enums';
import { accountApi } from '@/service/api/accountApi';

export default defineComponent({
    name: 'PhoneLogin',
    data() {
        let validateCaptcha = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入验证码'));
            } else {
                callback();
            }
        };
        let validatePhone = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请输入手机号'));
            } else {
                callback();
            }
        };
        return {
            ruleForm: {
                phone: undefined,
                captcha: undefined
            },
            rules: {
                phone: [
                    { validator: validatePhone, trigger: 'blur' }
                ],
                captcha: [
                    { validator: validateCaptcha, trigger: 'blur' }
                ],
            },
            captcha: {
                sendStatus: false,
                resendTime: 60,
                time: undefined
            }
        };
    },
    created() {
        if (localStg.get(EnumLocalStore.jwtTokenName)) {
            this.$router.push('/')
        }
    },
    methods: {
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    // 判断是手机号还是账号
                    loginApi.loginByPhone(this.ruleForm).then(result => {
                        if (result.code === 200) {
                            message.success("登录成功")
                            // 进入首页
                            let data = result.data
                            localStg.set(EnumLocalStore.jwtTokenName, data.token)
                            localStg.set('account', data.data.account)
                            localStg.set('userId', data.data.userId)
                            localStg.set('platformId', data.data.platformId)
                            this.$router.push('/')
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        sendCaptchaByPhone() {
            if (!this.ruleForm.phone) {
                return
            }
            accountApi.sendCaptchaByPhone({phone: this.ruleForm.phone}).then(result => {
                if (result.code === 200) {
                    message.success("验证码已发送至您的手机！")
                    this.captcha.sendStatus = true
                    this.captcha.time = setInterval(() => {
                        if (this.captcha.resendTime <= 1) {
                            clearInterval(this.captcha.time)
                            this.captcha.resendTime = 60
                            this.captcha.sendStatus = false
                        }
                        this.captcha.resendTime = this.captcha.resendTime - 1
                    }, 1000)
                }
            })
        },
        skipPage(router) {
            this.$router.push(router)
        }
    }
});
</script>

<style lang='css'>
@import "../../assets/css/login.css";
</style>
